import { formatNumber } from "@utils";
import { getLocale } from "i18n/utils";

export const formatAmount = (num = 0, digits = 2) =>
  formatNumber(num, {
    locale: getLocale(),
    options: {
      compactDisplay: "short",
      minimumFractionDigits: digits,
      notation: "compact",
    },
  });
